/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventNotesController', DinghyEventNotesController);

    DinghyEventNotesController.$inject = ['entity', '$http'];

    function DinghyEventNotesController(entity, $http) {
        var vm = this;
        vm.dinghyEvent = entity;
        vm.save = save;

        function save() {
            vm.isSaving = true;
            var projectNotesDTO = {
                id: vm.dinghyEvent.id,
                notes: vm.dinghyEvent.notes
            };
            $http.post('/api/board/dinghy-events/notes/', projectNotesDTO, null).then(onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };
    }
})();
